import Vue from 'vue'
import axios from 'axios'

const initState = {}

export default {
  namespaced: true,
  state: Vue.util.extend({}, initState),
  mutations: {},
  actions: {
    getAdminBlogs({ commit }, queries) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/admin-blogs`, { params: queries })
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    createAdminBlog({ commit }, blog) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-blogs`, blog)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    getAdminBlog({ commit }, { blogId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/admin-blogs/${blogId}`)
          .then((res) => resolve(res.data.blog))
          .catch((error) => reject(error))
      })
    },
    updateAdminBlog({ commit }, blog) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/admin-blogs/${blog.id}`, blog)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    deleteAdminBlog({ commit }, { blogId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/admin-blogs/${blogId}`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    adminPublishBlog({ commit }, blogId) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-blogs/${blogId}/publish`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    cloneAdminBlog({ commit }, { blogId }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin-blogs/${blogId}/clone`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    findAdminBlogByUniqueId({ commit }, uniqueId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/admin-blog/${uniqueId}/unique-id`)
          .then((res) => resolve(res.data.blog))
          .catch((error) => reject(error))
      })
    }
  },
  getters: {}
}